export default {
	acceptAndJoin: "Accept and Join Temple",
	acceptInvite: "Accept Invite",
	code: "Invite Code",
	createAccount: "Create Your Account",
	displayName: "Full Name",
	enterCode: "Enter the invite code you received",
	error: "Error creating account. Please try again.",
	invalidCode: "Invalid or expired code",
	invitedTo: "You have been invited to this temple",
	joiningTemple: "You are joining the temple: {temple}",
	loggedInAs: "You are logged in as {name} ({email})",
	ritualFunction: "Temple Function",
	ritualFunctionHint: "E.g.: Medium, Cambono, Ogã (optional)",
	submit: "Create Account",
	title: "Join as Member",
	validate: "Validate Code",
};
